import { render, staticRenderFns } from "./ConfectionTile.vue?vue&type=template&id=410dd8c0&"
import script from "./ConfectionTile.vue?vue&type=script&lang=js&"
export * from "./ConfectionTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports